export const defaultWaitlistInfoConfig = [
  [
    [
      {
        data: [
          {
            label: 'Applicant Email Address',
            dataKey: 'people.registrant.email',
          },
          {
            label: 'Property Address',
            dataKey: 'propertyInfo.propertyAddress',
          },
          { label: 'Unit Number', dataKey: 'propertyInfo.unitNumber' },
          {
            component: 'MapRenderer',
            map: {
              main_structure: 'Main Structure',
              adu: 'ADU',
              multifamily: 'Multifamily',
            },
            label: 'Rental Structure',
            dataKey: 'propertyInfo.rentalStructure',
          },
        ],
      },
    ],
  ],
];
